const linkStyle = { color: "white" };

const CityUnlockTermsOfService = ({ appName = "City Unlock" }) => {
  return (
    <div id="content">
      <p>
        By downloading or using the app, these terms will automatically apply to
        you – you should make sure therefore that you read them carefully before
        using the app. You’re not allowed to copy or modify the app, any part of
        the app, or our trademarks in any way. You’re not allowed to attempt to
        extract the source code of the app, and you also shouldn’t try to
        translate the app into other languages or make derivative versions. The
        app itself, and all the trademarks, copyright, database rights, and
        other intellectual property rights related to it, still belong to
        My Fortuna LLC.{" "}
      </p>
      <p>
        My Fortuna LLC is committed to ensuring that the app is as useful and
        efficient as possible. For that reason, we reserve the right to make
        changes to the app or to charge for its services, at any time and for
        any reason. We will never charge you for the app or its services without
        making it very clear to you exactly what you’re paying for.
      </p>
      <p>
        {`
        The ${appName} app stores and processes personal data that you have
        provided to us, to provide our Service. How we do this is described in
        our `}
        <a href="/privacy-policy/city-unlock/" style={linkStyle}>
          Privacy Policy
        </a>
        {`. It’s your responsibility to keep your phone and access to the app
        secure. We therefore recommend that you do not jailbreak or root your
        phone, which is the process of removing software restrictions and
        limitations imposed by the official operating system of your device. It
        could make your phone vulnerable to malware/viruses/malicious programs,
        compromise your phone’s security features and it could mean that the
        ${appName} app won’t work properly or at all.`}
      </p>

      <p>
        <strong>Who Can Use {appName}</strong>
      </p>
      <p>
        {`${appName} is not made for children. You may use the app only if you
        are at least 13 years old and have also reached the age at which you
        can consent on your own to the processing of your personal data in the
        country where you live (between 13 and 16, depending on the country).
        By using the app you confirm that you meet this requirement. The app
        does not ask for your age, but if we learn that an account belongs to
        someone under that age, we will close it and delete its data. `}
      </p>
      <p>
        {`You need a Google account to sign in. You are responsible for what
        happens under your account, and an account is for one person only. `}
      </p>

      <p>
        <strong>Stay Safe and Follow the Law</strong>
      </p>
      <p>
        {`${appName} rewards you for moving around your city, and you do that at
        your own risk. You are responsible for your own safety and for the
        safety of the people around you at all times. `}
      </p>
      <ul>
        <li>
          Never operate the app while driving. Start a drive before you set
          off, leave your phone alone while the vehicle is moving, and only
          touch it again once you are safely parked.
        </li>
        <li>
          Obey traffic laws and local rules, and pay attention to your
          surroundings when you walk or run.
        </li>
        <li>
          Do not enter private property, restricted areas or places that are
          closed or unsafe. A street or path appearing on the map does not mean
          that it is public, open, safe or legal for you to use.
        </li>
        <li>
          Only take on physical activity that suits your health and fitness.
        </li>
      </ul>
      <p>
        {`The streets, city limits and places in the app come from
        OpenStreetMap, a map made by volunteers, and they may be incomplete,
        out of date or wrong. ${appName} is a game about exploring, not a
        navigation or safety tool. Nothing in the app, including a street that
        is still locked, a place of a collection or a position on a
        leaderboard, is an instruction or an invitation to go anywhere. `}
      </p>

      <p>
        <strong>Location Tracking and Your Progress</strong>
      </p>
      <p>
        {`The app unlocks streets from your phone's GPS, whose accuracy varies
        with your device and surroundings. A street you covered may fail to
        unlock, and a street you did not cover may unlock. Tracking a walk, run
        or drive keeps using your location, your battery and your mobile data
        while your phone is locked, and your phone's operating system may pause
        or stop it. We do not guarantee that your progress, sessions, photos or
        rankings will be recorded, kept or free of errors. `}
      </p>

      <p>
        <strong>Leaderboards and Fair Play</strong>
      </p>
      <p>
        {`When you unlock streets or visit places of a collection, your name,
        your profile picture and your totals appear on your city's leaderboards,
        where other users can see them. You must earn your progress by actually
        travelling: you may not fake or alter your location, use an emulator or
        an automated tool, or manipulate your progress or the leaderboards in
        any other way. We may correct or remove progress and leaderboard
        entries that we believe were not earned fairly. Rankings have no
        monetary value and carry no prize. `}
      </p>

      <p>
        <strong>Your Photos and Comments</strong>
      </p>
      <p>
        {`${appName} lets you pin photos to the map. A photo that you share
        with everyone is public: every user of the app can see the picture,
        your comment, the place where it was pinned, the time, and your name
        and profile picture. A photo that you keep private can only be seen by
        you. We do not look at private photos except where that is needed to
        run the Service, to comply with the law or to look into a suspected
        breach of these terms. `}
      </p>
      <p>
        {`You keep ownership of the photos and comments you post. By sharing a
        photo with everyone, you give My Fortuna LLC a non-exclusive,
        royalty-free, worldwide license to store, reproduce and display it,
        with its comment, within the Service for as long as it stays posted.
        This license ends when you delete the post or your account. You confirm
        that you took the photo yourself or otherwise have the right to post
        it, and that posting it does not break the law or anyone's rights. `}
      </p>
      <p>You may not post or share anything that:</p>
      <ul>
        <li>
          is sexually explicit or pornographic, or shows nudity;
        </li>
        <li>
          sexualizes, exploits or endangers a child in any way. We have zero
          tolerance for such content: we remove it, close the account and
          report it to the relevant authorities where the law requires;
        </li>
        <li>
          harasses, threatens, demeans or promotes hatred or violence against a
          person or a group;
        </li>
        <li>
          invades someone's privacy, for example a photo of a person taken
          without their consent in a place where they expect privacy, or a
          photo or comment that reveals someone's home, vehicle registration,
          contact details or other personal information;
        </li>
        <li>is spam, advertising or a deliberately wrong location;</li>
        <li>
          is illegal, or infringes someone else's copyright, trademark or other
          rights.
        </li>
      </ul>
      <p>
        {`You also may not use the app to follow, monitor or locate another
        person, to collect other users' information, or to interfere with the
        Service or access it by automated means. `}
      </p>

      <p>
        <strong>Reporting and Moderation</strong>
      </p>
      <p>
        {`You can report any shared photo from within the app: open the post,
        tap its menu and choose “Report post”. A post that has been reported by
        several users is hidden from the map automatically. You can also write
        to us at support@myfortuna.app. We review reports as quickly as we can
        and we may remove any content, hide it, or suspend or close the account
        of anyone who breaks these terms, at our discretion and without
        notice. You can delete your own posts at any time. `}
      </p>
      <p>
        {`We do not check content before it is posted, and what users post is
        their own responsibility, not ours. We are not liable for content
        posted by users, and you may come across content that you find
        inaccurate or objectionable. `}
      </p>

      <p>
        <strong>Free Plan and {appName} Max</strong>
      </p>
      <p>
        {`${appName} is free to use within these limits: your streets are kept
        in one city at a time, you can follow one collection at a time, and you
        can keep up to three private photos. `}
      </p>
      <p>
        {`On the free plan, changing to another city permanently erases the
        streets you unlocked in the city you leave, together with your
        leaderboard entry there. The app asks you to confirm before this
        happens, and it cannot be undone. `}
      </p>
      <p>
        {`${appName} Max is an optional subscription that removes these limits:
        it keeps your streets in every city, and lets you follow as many
        collections and keep as many private photos as you like. We may change
        what the free plan and Max include over time. `}
      </p>
      <ul>
        <li>
          Max is sold as a monthly or a yearly subscription through Google Play
          or the Apple App Store. The price is shown in the store before you
          buy, and payment is charged to your store account when you confirm
          the purchase.
        </li>
        <li>
          The subscription renews automatically for the same period and at the
          then-current price unless you cancel it at least 24 hours before the
          end of the current period.
        </li>
        <li>
          You can manage or cancel your subscription at any time in your{" "}
          <a
            href="https://play.google.com/store/account/subscriptions"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            Google Play
          </a>{" "}
          or{" "}
          <a
            href="https://apps.apple.com/account/subscriptions"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            App Store
          </a>{" "}
          subscription settings. When you cancel, Max stays active until the
          end of the period you have paid for.
        </li>
        <li>
          Uninstalling the app or deleting your {appName} account does not
          cancel your subscription.
        </li>
        <li>
          Payments are handled by the store. Refunds are given by Google or
          Apple under their own policies, and we do not refund part of a
          period, except where the law requires it.
        </li>
        <li>
          A subscription belongs to the {appName} account it was bought with.
          “Restore purchases” moves a subscription bought with your store
          account to the {appName} account you are signed in to.
        </li>
      </ul>
      <p>
        {`When Max ends, nothing is erased at that moment, and the limits of the
        free plan apply again. Your cities stay as they are, but the next city
        you leave is erased as described above. The first collection you added
        is still followed, and the others are paused until Max is back. Your
        private photos stay where they are, but you cannot add another until
        you have fewer than three. `}
      </p>

      <p>
        <strong>Deleting Your Account</strong>
      </p>
      <p>
        {`You can delete your account at any time from your profile in the app.
        This permanently deletes your unlocked streets, visited places,
        leaderboard entries, sessions, private photos and every photo you
        shared, and it cannot be undone. Cancel ${appName} Max in your store's
        subscription settings first, or you will keep being charged. `}
      </p>

      <div>
        <p>
          <strong>Third-Party Services and Map Data</strong>
        </p>
        <p>
          The app does use third-party services that declare their Terms and
          Conditions. Map data is © OpenStreetMap contributors and is available
          under the Open Database License.
        </p>
        <p>
          Link to Terms and Conditions of third-party service providers used by
          the app
        </p>
        <ul>
          <li>
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/terms/analytics"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Google Analytics for Firebase
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/terms/crashlytics"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Firebase Crashlytics
            </a>
          </li>
          <li>
            <a
              href="https://www.openstreetmap.org/copyright"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              OpenStreetMap
            </a>
          </li>
        </ul>
      </div>
      <p>
        You should be aware that there are certain things that My Fortuna LLC
        will not take responsibility for. Certain functions of the app will
        require the app to have an active internet connection. The connection
        can be Wi-Fi or provided by your mobile network provider, but My Fortuna
        LLC cannot take responsibility for the app not working at full
        functionality if you don’t have access to Wi-Fi, and you don’t have any
        of your data allowance left.
      </p>
      <p></p>
      <p>
        If you’re using the app outside of an area with Wi-Fi, you should
        remember that the terms of the agreement with your mobile network
        provider will still apply. As a result, you may be charged by your
        mobile provider for the cost of data for the duration of the connection
        while accessing the app, or other third-party charges. In using the app,
        you’re accepting responsibility for any such charges, including roaming
        data charges if you use the app outside of your home territory (i.e.
        region or country) without turning off data roaming. If you are not the
        bill payer for the device on which you’re using the app, please be aware
        that we assume that you have received permission from the bill payer for
        using the app.
      </p>
      <p>
        Along the same lines, My Fortuna LLC cannot always take responsibility
        for the way you use the app i.e. You need to make sure that your device
        stays charged – if it runs out of battery and you can’t turn it on to
        avail the Service, My Fortuna LLC cannot accept responsibility.
      </p>
      <p>
        With respect to My Fortuna LLC’s responsibility for your use of the
        app, when you’re using the app, it’s important to bear in mind that
        although we endeavor to ensure that it is updated and correct at all
        times, we do rely on third parties to provide information to us so that
        we can make it available to you. My Fortuna LLC accepts no liability for
        any loss, direct or indirect, you experience as a result of relying
        wholly on this functionality of the app.
      </p>
      <p>
        <strong>Disclaimer and Limitation of Liability</strong>
      </p>
      <p>
        {`The app is provided “as is” and “as available”, without warranties of
        any kind. To the fullest extent permitted by law, My Fortuna LLC is not
        liable for any injury, accident, fine, penalty, damage to property or
        other loss that you or anyone else suffers while you use the app or
        travel to unlock streets or visit places, nor for any loss of data,
        progress or rankings. Nothing in these terms limits a liability or a
        right that cannot be limited under the law that applies to you. `}
      </p>
      <p>
        <strong>Updates and Termination</strong>
      </p>
      <p>
        At some point, we may wish to update the app. The app is currently
        available on Android &amp; iOS – the requirements for the both
        systems(and for any additional systems we decide to extend the
        availability of the app to) may change, and you’ll need to download the
        updates if you want to keep using the app. My Fortuna LLC does not
        promise
        that it will always update the app so that it is relevant to you and/or
        works with the Android &amp; iOS version that you have installed on your
        device. However, you promise to always accept updates to the application
        when offered to you, We may also wish to stop providing the app, and may
        terminate use of it at any time without giving notice of termination to
        you. Unless we tell you otherwise, upon any termination, (a) the rights
        and licenses granted to you in these terms will end; (b) you must stop
        using the app, and (if needed) delete it from your device.
      </p>
      <p>
        <strong>Additional Terms for the Apple App Store</strong>
      </p>
      <p>
        {`If you downloaded the app from the Apple App Store, the following also
        applies. These terms are an agreement between you and My Fortuna LLC
        only, not with Apple, and My Fortuna LLC, not Apple, is solely
        responsible for the app and its content. You are granted a
        non-transferable license to use the app on Apple-branded devices that
        you own or control, as permitted by the Usage Rules in the Apple Media
        Services Terms and Conditions. Apple has no obligation to provide any
        maintenance or support for the app. If the app fails to conform to any
        applicable warranty, you may notify Apple, and Apple will refund the
        purchase price of the app, if any; to the maximum extent permitted by
        law, Apple has no other warranty obligation with respect to the app.
        Apple is not responsible for addressing any claim by you or a third
        party relating to the app or your possession or use of it, including
        product liability claims, claims that the app fails to conform to a
        legal or regulatory requirement, claims under consumer protection or
        privacy laws, and claims that the app infringes a third party's
        intellectual property rights. You confirm that you are not located in a
        country that is subject to a U.S. Government embargo or designated as a
        “terrorist supporting” country, and that you are not on any U.S.
        Government list of prohibited or restricted parties. Apple and its
        subsidiaries are third-party beneficiaries of these terms and, once you
        accept them, have the right to enforce them against you. `}
      </p>
      <p>
        <strong>Changes to This Terms and Conditions</strong>
      </p>
      <p>
        We may update our Terms and Conditions from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Terms and Conditions on this page.
      </p>
      <p>These terms and conditions are effective as of 2026-10-12</p>{" "}
      <p>
        <strong>Contact Us</strong>
      </p>{" "}
      <p>
        If you have any questions or suggestions about our Terms and Conditions,
        do not hesitate to contact us at support@myfortuna.app.
      </p>
    </div>
  );
};

export default CityUnlockTermsOfService;
